import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import { isObservable, Observable, of } from 'rxjs';

@Pipe({ name: 'rtToObservable' })
export class ToObservablePipe implements PipeTransform {
  public transform<T>(value: T | Observable<T>): Observable<T> {
    if (isObservable(value)) {
      return value;
    }

    return of(value);
  }
}
